/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isAppAuthSelector } from './ConfigSelectors';
import { logInAppExposure, logPublicExposure } from '../api/ExperimentTreatmentApi';
import {
/* MON569 */
MON569_PARAMETER_OPTIONS
/* MON607 */
, MON607_PARAMETER_OPTIONS
/* MON606 */
, MON606_PUBLIC_TREATMENT_KEY, MON606_PARAMETER_KEY, MON606_TREATMENT_KEY // MON606_PARAMETER_OPTIONS,
} from '../constants/ExperimentConstants'; // import { hasScopeSelector } from './ScopeSelectors';
// import {
//   MARKETING,
//   SALES,
//   SERVICE,
// } from 'self-service-api/constants/ProductLines';

export const experimentTreatmentSelector = ({
  experimentTreatments: {
    treatments
  }
}, treatmentKey) => {
  if (!treatments) return null;
  return treatments[treatmentKey];
};
export const experimentParameterSelector = (state, treatmentKey, parameterKey) => {
  const treatment = experimentTreatmentSelector(state, treatmentKey);
  if (!treatment) return null;
  return treatment.parameters[parameterKey];
};
export const isExperimentTreatmentRequestLoadingSelector = ({
  experimentTreatments: {
    isLoading
  }
}) => isLoading;
export const useLogExposure = ({
  publicTreatmentKey,
  inAppTreatmentKey,
  deps = []
}) => {
  const isAppAuth = useSelector(state => isAppAuthSelector(state));
  useEffect(() => {
    if (isAppAuth && inAppTreatmentKey) {
      logInAppExposure(inAppTreatmentKey);
    } else if (!isAppAuth && publicTreatmentKey) {
      logPublicExposure(publicTreatmentKey);
    }
  }, [inAppTreatmentKey, publicTreatmentKey, ...deps]);
};
export const mon607VariantSelector = () => {
  return MON607_PARAMETER_OPTIONS.CONTROL;
}; // const mon570EligibleProductLines = [MARKETING, SALES, SERVICE];

export const useMon570 = () =>
/*productLine*/
{
  // if (!mon570EligibleProductLines.includes(productLine)) {
  //   return { isVariant: false };
  // }
  return {
    isVariant: false
  };
};
export const mon569VariantSelector = () => {
  return MON569_PARAMETER_OPTIONS.CONTROL;
};
export const isMon569VariantSelector = state => {
  const value = mon569VariantSelector(state);
  return value === MON569_PARAMETER_OPTIONS.STARTER || value === MON569_PARAMETER_OPTIONS.ADVANCED;
};
export const mon606VariantSelector = state => {
  const publicParam = experimentParameterSelector(state, MON606_PUBLIC_TREATMENT_KEY, MON606_PARAMETER_KEY);
  const authedParam = experimentParameterSelector(state, MON606_TREATMENT_KEY, MON606_PARAMETER_KEY);
  return isAppAuthSelector(state) ? authedParam : publicParam;
}; // Hard-coded to return false until next iteration of this experiment
// const isNewUserForMon606InApp = () => {
//   return false;
// };
// const isFreeUserForMon606InApp = state => {
//   // Logic ported from settings-users-ui
//   // https://git.hubteam.com/HubSpot/settings-ui-users/blob/07ab6d005d9175d0ac7ab3e94150eb2bb1527391/static/js/app/selectors/auth.js#L149
//   // Teams is a starter+ feature and is also avalible on free v1,
//   // so we can safely assume that any hub that does not have teams is
//   // a free-v2 only hub with no other parcels
//   const hasTeamsAccessScope = hasScopeSelector(state, 'teams-access');
//   return !hasTeamsAccessScope;
// };
// const isEligibleForMon606Selector = state => {
//   const isAuthed = isAppAuthSelector(state);
//   const isNewUser = isNewUserForMon606InApp(state);
//   const isFreeUser = isFreeUserForMon606InApp(state);
//   // All un-authed public pricing page users are eligible for cbx-606p
//   // Only newly made, free hubs are eligible in-app for cbx-606
//   return !isAuthed || (isNewUser && isFreeUser);
// };

export const isMon606VariantSelector = () => {
  // const isEligible = isEligibleForMon606Selector(state);
  // const treatment = mon606VariantSelector(state);
  // return isEligible && treatment === MON606_PARAMETER_OPTIONS.VARIANT;
  return false;
};
export const useMon606LogExposure = () => {// const isEligible = useSelector(isEligibleForMon606Selector);
  // const authedTreatmentKey = isEligible ? MON606_TREATMENT_KEY : null;
  // useLogExposure({
  //   publicTreatmentKey: MON606_PUBLIC_TREATMENT_KEY,
  //   inAppTreatmentKey: authedTreatmentKey,
  // });
};
export const isMon606InAppRunningForPublicUserSelector = () => {
  return false; // const isAuthed = isAppAuthSelector(state);
  // const experiment = experimentTreatmentSelector(state, MON606_TREATMENT_KEY);
  // return (
  //   !isAuthed && experiment && experiment.status && experiment.status.isActive
  // );
};